// @flow
/* eslint-disable no-use-before-define */
import * as React from 'react'
import { styled } from 'mz-ui-kit'
import importWithRetry from 'mz-utils/importWithRetry'

// Types
export type Props = {
  country: string,
  size: $Keys<typeof SIZES_CONTAINER>,
}

const SIZES_CONTAINER = {
  xs: { width: '12px', height: '12px' },
  sm: { width: '14px', height: '14px' },
  md: { width: '18px', height: '18px' },
  lg: { width: '24px', height: '24px' },
}

const Container = styled<{
  $size: $Keys<typeof SIZES_CONTAINER>,
}>('span', ({ $size }) => ({
  verticalAlign: '-.125em',
  display: 'inline-block',
  overflow: 'hidden',
  ...SIZES_CONTAINER[$size],
}))

/**
 * A flag component which lazy-load actual flags sprite component
 * which is about 90kb gzipped. Have a way to customize size but
 * only with `size` prop.
 */
class Flag extends React.Component<Props> {
  static displayName = 'Icon(flag)'

  static defaultProps = {
    size: 'sm',
    country: 'ar',
  }

  flagsComponent = null

  unmounted = false

  UNSAFE_componentWillMount() {
    importWithRetry(() =>
      import(/* webpackChunkName: "flags" */ './utils/allFlags')
    ).then(this.handleFlagsLoaded)
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  handleFlagsLoaded = (AllFlags: any) => {
    this.flagsComponent = AllFlags.default
    if (!this.unmounted) {
      this.forceUpdate()
    }
  }

  render() {
    const { country, size } = this.props
    const AllFlags = this.flagsComponent
    const child = AllFlags ? (
      <AllFlags $country={country} $size={size} />
    ) : (
      <span />
    )
    return <Container $size={size}>{child}</Container>
  }
}

export default Flag
